import React from "react";

import BackgroundWrapper from "_components/atoms/backgroundWrapper";
import EmptyView         from "_components/atoms/emptyView";

import useStyles from "./styles";

const DashboardErrorPage = ( { customMsg } ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<BackgroundWrapper className = { classes.dashboardErrorPage }>
			<EmptyView
				customMsg = { customMsg }
			/>
		</BackgroundWrapper>
	);
};

export default DashboardErrorPage;
